<template>
  <div>
    <v-card class="main-container">
      <div class="d-flex align-center justify-space-between mb-3">
        <div>Create a Streak</div>
        <div class="yellow-card d-flex">
          <span>
            <v-img :src="thunder" class="mr-1"></v-img>
          </span>
          <span> {{ current_day }} Day(s) </span>
        </div>
      </div>

      <div class="progress-bar">
        <div class="milestones">
          <div
            v-for="(milestone, index) in milestones"
            :key="index"
            :class="['milestone-reward', `milestone-${index + 1}`]"
          >
            {{ milestone.reward }}
          </div>
        </div>

        <div class="progress-line-container">
          <div class="progress-line">
            <div
              class="progress-fill"
              :style="{ width: `${streakProgress}%` }"
            ></div>
          </div>

          <div class="coin-milestones">
            <img
              v-for="index in milestones.length"
              :key="index"
              src="./coin_icon.svg"
              :class="`coin-icon coin-${index}`"
            />
          </div>
        </div>

        <div class="days">
          <div
            v-for="(milestone, index) in milestones"
            :key="index"
            :class="`day day-${index + 1}`"
          >
            {{ milestone.day }} Days
          </div>
        </div>
      </div>
      <br />
      <br />

      <div class="d-flex align-center justify-space-between my-5">
        <div>Daily Tasks</div>
        <div class="yellow-card d-flex align-center justify-center">
          <span class="daily-task-count">100/300</span>
          <img src="./coin_icon.svg" class="ml-1" />
        </div>
      </div>
      <v-row>
        <v-col
          v-for="(item, index) in dailyTask"
          :key="index"
          cols="12"
          sm="12"
          md="12"
        >
          <v-card
            class="pa-3"
            style="height: 70px"
            @click="handleCardClick(index)"
          >
            <div class="d-flex justify-space-between">
              <div class="d-flex align-center justify-start">
                <div class="card-icon mr-5"><img :src="item.file" /></div>
                <div class="d-flex align-start justify-start flex-column">
                  <div class="card-title">{{ item.key }}</div>
                  <div class="card-sub-title d-flex">
                    Earn:
                    <span class="card-span">{{ item.coin_reward }}</span>
                    <div>
                      <img src="./coin_icon.svg" class="ml-1" />
                    </div>
                  </div>
                </div>
              </div>
              <v-card-actions>
                <v-icon v-if="item.is_completed" color="blue" class="mr-2"
                  >mdi-check-circle</v-icon
                >
                <v-radio
                  v-else
                  disabled
                  color="blue"
                  :value="item.key"
                  v-model="item.is_completed"
                ></v-radio>
              </v-card-actions>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import newAxios from "@/api/newAxios";
import apiUrl from "@/common/apiUrl";
import { mapActions } from "vuex";
export default {
  data() {
    return {
      thunder: require("@/assets/images/trending/thunder.svg"),
      streakProgress: 0,
      milestones: [],
      dailyTask: [],
      current_day: null,
    };
  },
  mounted() {
    this.getDailyTaskData();
    this.getStreakDetail();
  },
  methods: {
    ...mapActions({
      toggleAddTradeModal: "addTrade/toggleTradeModal",
    }),
    getDailyTaskData() {
      const onSuccess = (res) => {
        this.dailyTask = res.data.data;
      };
      const onFailure = () => {};
      newAxios("get", apiUrl.GET_DAILY_TASK_DATA, {
        onSuccess,
        onFailure,
        isTokenRequired: true,
      });
    },
    getStreakDetail() {
      const onSuccess = (res) => {
        this.current_day = res.data.data.current_day;
        this.streakProgress = res.data.data.percentage;
        this.milestones = res.data.data.rewards;
      };
      const onFailure = () => {};
      newAxios("get", apiUrl.GET_STREAK_DETAIL, {
        onSuccess,
        onFailure,
        isTokenRequired: true,
      });
    },
    handleCardClick(index) {
      if (index === 1) {
        // Redirect to ProfilePage
        this.$router.push({ name: "HomePage" });
      } else if (index === 2) {
        // Open add trade dialog
        this.addTrade();
      } else if (index === 0) {
        // Redirect to ExpertPage
        this.$router.push({ name: "copyTrade" });
      }
    },
    addTrade() {
      // this.trade_form_data.flag = true;
      this.toggleAddTradeModal({
        show: true,
        type: "add",
        filter_by: this.filter_by,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.card-icon {
  background-color: #fff7e6;
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.card-title {
  font-family: Avenir;
  font-size: 14px;
  font-weight: 500;
  line-height: 19.12px;
  text-align: center;
  color: #333333;
}
.card-sub-title {
  font-family: Avenir;
  font-size: 14px;
  font-weight: 500;
  line-height: 19.12px;
  text-align: center;
  color: #33333399;
}
.card-span {
  font-family: Avenir;
  font-size: 14px;
  font-weight: 900;
  line-height: 19.12px;
  text-align: center;
  color: black;
}
.main-container {
  padding: 30px;
  height: fit-content;
  border-radius: 14px;
  box-shadow: 2px 8px 14px rgba(49, 93, 146, 0.06);
}

.yellow-card {
  padding: 6px 8px;
  border-radius: 8px;
  background: #fff7e5;
  color: #ffb800;
  font-weight: bold;
  color: #333333;
}

.progress-bar {
  position: relative;
  padding-top: 10px;
  margin-top: 2rem;
}

.milestones {
  position: absolute;
  top: -5px;
  width: 100%;
}

.milestone-reward {
  position: absolute;
  font-family: Avenir;
  font-size: 14px;
  font-weight: 900;
  text-align: center;
  color: #cdab35;
}

.milestone-1 {
  left: 27%;
}
.milestone-2 {
  left: 65%;
}
.milestone-3 {
  left: 95%;
}

.progress-line-container {
  position: relative;
  height: 15px;
  margin: 20px 0;
}

.progress-line {
  background: #d9d9d9;
  height: 15px;
  border-radius: 8px;
  overflow: hidden;
}

.progress-fill {
  background: linear-gradient(
    102.02deg,
    #d6c58d 3.12%,
    #ffe68e 52%,
    #dcc05c 95.14%
  );
  height: 100%;
  border-radius: 8px;
}

.coin-milestones {
  position: absolute;
  top: -5px;
  width: 100%;
}

.coin-icon {
  position: absolute;
  height: 20px;
}

.coin-1 {
  left: 30%;
}
.coin-2 {
  left: 66%;
  height: 24px;
}
.coin-3 {
  left: 97%;
  height: 28px;
}

.days {
  position: absolute;
  width: 100%;
  text-align: center;
  margin-top: 10px;
  font-family: Avenir;
  font-size: 12px;
  font-weight: bold;
  color: #000;
}

.day {
  position: absolute;
  text-align: center;
}

.day-1 {
  left: 28%;
}
.day-2 {
  left: 65%;
}
.day-3 {
  left: 92%;
}

.daily-task-count {
  color: #333333;
  font-family: Avenir;
  font-size: 13px;
  font-weight: 900;
  text-align: center;
}
</style>
